<template>
  <div class="cmp-catalog-releases-sidewindow-release-setup dt-page">
    <TextField2
      id="artist_name"
      :placeholder="$t('artist_name')"
      :label="$t('artist_name')"
      :value="selectedArtistDetails.artist.artist_name"
      :disabled="false"
      @blur="e => onTextFieldValueChange(e)"
    />
    <TextField2
      id="sort_name"
      :placeholder="$dft.capHead($t('sort_name'))"
      :label="$dft.capHead($t('sort_name'))"
      :value="selectedArtistDetails.artist.sort_name"
      :disabled="false"
      @blur="e => onTextFieldValueChange(e)"
    />
    <TextField2
      id="url1"
      class="m1"
      :placeholder="$t('Url')"
      :label="$t('Url')"
      :value="selectedArtistDetails.artist.url1 || ''"
      @blur="e => onTextFieldValueChange(e)"
    />
    <TextField2
      id="url2"
      class="m1"
      :placeholder="$t('Url2')"
      :label="$t('Url2')"
      :value="selectedArtistDetails.artist.url2 || ''"
      @blur="e => onTextFieldValueChange(e)"
    />

    <TextField2
      id="amg_id"
      :placeholder="$t('amg_id')"
      :label="$t('identifier')"
      :value="selectedArtistDetails.artist.amg_id"
      @blur="e => onTextFieldValueChange(e)"
    />
    <TextField2
      id="mechanical_id"
      :placeholder="$t('mechanical_id')"
      :label="$t('mechanical_id')"
      :value="selectedArtistDetails.artist.mechanical_id"
      @blur="e => onTextFieldValueChange(e)"
      :bb="'0px'"
    />
  </div>
</template>
<script>
import { tv } from "../../../../models/text-value.model";


export default {
  props: {
    selectedArtistDetails: {
      type: Object
    }
  },

  data: function() {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: true
      },
      releaseArtist: "",
      releaseTitle: "",
      releaseDate: "",
      releaseCode: ""
    };
  },
  methods: {
    onTextFieldValueChange: function(e) {
      const payload = {
        name: e.name,
        value: e.value
      };
      this.$emit("changed", payload);
      console.log("WERERTYUPOIUN", payload);
    }
  },
  computed: {}
};
</script>
<style lang="scss">
.cmp-catalog-releases-sidewindow-release-setup {
  .flex-container {
    display: flex;
    padding: 10px;
    .flex-item {
      flex: 0.25;
      padding: 10px;
    }
  }
}
</style>
